import { useContext } from 'react';
import { SideBarVisibilityContext } from '../contexts/sidebar-visibility-context';

const useSideBarVisibility = () => useContext(SideBarVisibilityContext);

export default useSideBarVisibility;
